import FilterContainer from 'components/FilterContainer';
import StyledSection from './TopSection.styles';

const TopSection:React.FC<
{title: string; hideFilter?: boolean}
> = (props: {title: string; hideFilter?: boolean}) => {
  return (
    <StyledSection>
      <h1 className="top-section__title">{props.title}</h1>
      {!props.hideFilter && <FilterContainer className="header-filter" />}
    </StyledSection>
  );
};

export default TopSection;
